/**
 * Consistent section wrapper for Payroll Recon workflow blocks.
 */
export default function ReconSection({
  step,
  title,
  description,
  headerCenter,
  headerExtra,
  children,
  className = '',
}) {
  const headerClass = headerCenter
    ? 'section-header grid grid-cols-1 items-center gap-3 sm:grid-cols-[1fr_auto_1fr]'
    : 'section-header flex flex-wrap items-center justify-between gap-3';

  return (
    <section className={`card-panel overflow-hidden ${className}`}>
      <div className={headerClass}>
        <div className="flex items-start gap-3 sm:justify-self-start">
          {step != null && <span className="step-badge">{step}</span>}
          <div>
            <h3 className="text-sm font-semibold text-slate-100">{title}</h3>
            {description && <p className="mt-0.5 text-xs text-slate-400">{description}</p>}
          </div>
        </div>
        {headerCenter && (
          <div className="flex justify-center sm:justify-self-center">{headerCenter}</div>
        )}
        {headerExtra && <div className="flex justify-end sm:justify-self-end">{headerExtra}</div>}
      </div>
      <div className="p-5">{children}</div>
    </section>
  );
}
